export const csvAcceptedFormats = [{ extension: '.csv', mimeType: 'text/csv' }]
